import { BenefFicheProfilModel } from 'src/graphql/generated-types';

const ActionPrefix = '[BeneficaryEdit] ';

export class BeneficiaryGetBeneficiaryByIdAction {
    public static type = ActionPrefix + 'GetBeneficaryById';

    constructor(public id: number) {
    }
}

export class BeneficiarySetBeneficiaryIdAction {
    public static type = ActionPrefix + 'SetBeneficaryId';

    constructor(public id: number) {
    }
}

export class BeneficiaryLoadRelatedListAction {
    public static type = ActionPrefix + 'BeneficiaryLoadRelatedList';
}

export class BeneficiaryLoadReferenceYearsListAction {
    public static type = ActionPrefix + 'BeneficiaryLoadReferenceYearsList';
}

export class BeneficiarySaveProfileAction {
    public static type = ActionPrefix + 'BeneficiarySaveProfileAction';

    constructor(public beneficiary: BenefFicheProfilModel) {
    }
}
